/**
 * 圖片工具函數 - 對齊 TaskyVenture
 */
export const getImageUrl = (path: string): string => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const baseUrl = process.env.PUBLIC_URL || '';
    return `${baseUrl}${normalizedPath}`;
};

/** 預載圖片，成功回傳 true，失敗回傳 false */
export const preloadImage = (imageUrl: string): Promise<boolean> => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
    });
};
